import {useAuthStore} from "@src/stores/auth";
import {db} from "@src/services/db";

export const MessageStatusListener = () => {
    const auth = useAuthStore();

    const userId = auth.user?.id;
    if (!userId) return;
    // @ts-ignore
    window.websockets.private(`user.${userId}`)
        .listen('.MessageStatusUpdate', async (event: any) => {
            await db.messages.update(event.message_id, {
                status: event.status
            })

            const session = await db.sessions.get(event.session_id)

            if (session && session.last_message?.id === event.message_id) {
                await db.sessions.put({
                    ...session,
                    last_message: {
                        ...session.last_message,
                        status: event.status,
                    }
                } as any)
            }
        })
};